var constants = require('../constants');
var api = require('../../../utils/api');
var routerActions = require('react-router-redux').routerActions;
var passwordUtils = require('../passwordUtils');
var commonActions = require('../../common/actions/common');

var ResetPassword = (function() {

    var _requestReset = function() {
        return {
            type: constants.CREATE_RESET_REQUEST
        };
    }

    var _createResetSuccess = function(data) {
        return {
            type: constants.CREATE_RESET_SUCCESS,
            data: data.response,
            meta: {
                analytics: {
                    eventType: constants.CREATE_RESET_SUCCESS,
                    actionValue: 'response',
                    labelValue: 'success'
                }
            }
        };
    }

    var _createResetError = function(error) {
        return {
            type: constants.CREATE_RESET_ERROR,
            errors: error.data,
            meta: {
                analytics: {
                    eventType: constants.CREATE_RESET_ERROR,
                    actionValue: 'response',
                    labelValue: 'failure'
                }
            }
        };
    }

    var _validationError = function(error){
        return {
            type: constants.CREATE_RESET_ERROR,
            errors: error
        };
    }

    var _clearError = function() {
        return {
            type: constants.CLEAR_CREATE_RESET_ERROR
        };
    }

    var _resetPassword = function(token, password, rePassword) {
        return function(dispatch) {
            passwordUtils.validate_password_reset(password, rePassword)
                .then(function(result) {
                    if (result === true) {
                        dispatch(_requestReset());
                        api.post('/proxy/v1/users/password-reset/' + token, {
                            "password": password
                        }).then(function(data) {
                            dispatch(_createResetSuccess(data));
                            dispatch(routerActions.push('/login'));
                        }).catch(function(error) {
                            if(error.response){
                                dispatch(_createResetError(error.response));
                            }else{
                                dispatch(commonActions.setGenericError('', error.message));
                            }
                        });
                    } else {
                        dispatch(_validationError(result));
                    }
                })
        };
    }

    var _resetPasswordWithAccessToken = function (password, accessToken) {
        var oldPassword = "MTHCustomCl!nic";

        return function (dispatch) {
            // reusing password validation
            // only 1 input field, so length is only real check
            passwordUtils.validate_password_reset(password, password).then(function (result) {
                if (result === true) {
                    dispatch(_requestReset());
                    api.put('/proxy/v1/users/password-reset', {
                        "newPassword": password,
                        "oldPassword": oldPassword,
                    }, accessToken).then(function (data) {
                        dispatch(_createResetSuccess(data));
                        dispatch(routerActions.push('/education'));
                    }).catch(function (error) {
                        if (error.response) {
                            dispatch(_createResetError(error.response));
                        } else {
                            dispatch(commonActions.setGenericError('', error.message));
                        }
                    });
                } else {
                    dispatch(_validationError(result));
                }
            })
        }
    }

    return {
        resetPassword: _resetPassword,
        resetPasswordWithAccessToken: _resetPasswordWithAccessToken,
        clearError: _clearError
    }
})();

module.exports = ResetPassword;



// WEBPACK FOOTER //
// ./src/common/modules/password/actions/password-reset.js